import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

function analyticsBase(clientViewId) {
  return `/views/${clientViewId}/casamapa/analytics`;
}

export function getCasaMapaAdminAnalyticsSummary(clientViewId, params = {}) {
  return clientPortalRequest(`${analyticsBase(clientViewId)}/summary${buildClientQuery(params)}`);
}

export function getCasaMapaAdminAnalyticsTraffic(clientViewId, params = {}) {
  return clientPortalRequest(`${analyticsBase(clientViewId)}/traffic${buildClientQuery(params)}`);
}

export function getCasaMapaAdminAnalyticsSearches(clientViewId, params = {}) {
  return clientPortalRequest(`${analyticsBase(clientViewId)}/searches${buildClientQuery(params)}`);
}

export function getCasaMapaAdminAnalyticsListings(clientViewId, params = {}) {
  return clientPortalRequest(`${analyticsBase(clientViewId)}/listings${buildClientQuery(params)}`);
}

export function getCasaMapaAdminAnalyticsLeads(clientViewId, params = {}) {
  return clientPortalRequest(`${analyticsBase(clientViewId)}/leads${buildClientQuery(params)}`);
}

export function getCasaMapaAdminAnalyticsConversions(clientViewId, params = {}) {
  return clientPortalRequest(`${analyticsBase(clientViewId)}/conversions${buildClientQuery(params)}`);
}

export function getCasaMapaAdminAnalyticsMarket(clientViewId, params = {}) {
  return clientPortalRequest(`${analyticsBase(clientViewId)}/market${buildClientQuery(params)}`);
}

export function getCasaMapaAdminAnalyticsMarketTrend(clientViewId, params = {}) {
  return clientPortalRequest(
    `${analyticsBase(clientViewId)}/market-price-trend${buildClientQuery(params)}`
  );
}

export function getCasaMapaAdminAnalyticsTimeOnMarket(clientViewId, params = {}) {
  return clientPortalRequest(
    `${analyticsBase(clientViewId)}/time-on-market${buildClientQuery(params)}`
  );
}

export function getCasaMapaAdminAnalyticsPriceMovement(clientViewId, params = {}) {
  return clientPortalRequest(
    `${analyticsBase(clientViewId)}/price-movement${buildClientQuery(params)}`
  );
}

export function getCasaMapaAdminGa4AnalyticsStatus(clientViewId) {
  return clientPortalRequest(`${analyticsBase(clientViewId)}/ga4/status`);
}

export function getCasaMapaAdminGa4AnalyticsSummary(clientViewId, params = {}) {
  return clientPortalRequest(`${analyticsBase(clientViewId)}/ga4/summary${buildClientQuery(params)}`);
}

export function getCasaMapaAdminGa4AnalyticsTraffic(clientViewId, params = {}) {
  return clientPortalRequest(`${analyticsBase(clientViewId)}/ga4/traffic${buildClientQuery(params)}`);
}

export function getCasaMapaAdminGa4AnalyticsEngagement(clientViewId, params = {}) {
  return clientPortalRequest(
    `${analyticsBase(clientViewId)}/ga4/engagement${buildClientQuery(params)}`
  );
}

/** API bundle compatible with StudioAnalyticsSection. */
export const casaMapaAdminClientViewAnalyticsApi = {
  getAnalyticsSummary: getCasaMapaAdminAnalyticsSummary,
  getAnalyticsTraffic: getCasaMapaAdminAnalyticsTraffic,
  getAnalyticsSearches: getCasaMapaAdminAnalyticsSearches,
  getAnalyticsListings: getCasaMapaAdminAnalyticsListings,
  getAnalyticsLeads: getCasaMapaAdminAnalyticsLeads,
  getAnalyticsConversions: getCasaMapaAdminAnalyticsConversions,
  getAnalyticsMarket: getCasaMapaAdminAnalyticsMarket,
  getAnalyticsCampaigns: async () => ({}),
  getAnalyticsTimeOnMarket: getCasaMapaAdminAnalyticsTimeOnMarket,
  rebuildAnalytics: async () => ({}),
  exportAnalyticsReport: async () => ({}),
  getGa4AnalyticsStatus: getCasaMapaAdminGa4AnalyticsStatus,
  getGa4AnalyticsSummary: getCasaMapaAdminGa4AnalyticsSummary,
  getGa4AnalyticsTraffic: getCasaMapaAdminGa4AnalyticsTraffic,
  getGa4AnalyticsEngagement: getCasaMapaAdminGa4AnalyticsEngagement,
  syncGa4Analytics: async () => ({}),
};
